import React from "react";
import { Box } from "@mui/material";
import _ from "lodash";
import { pluralize } from "components/v2/views/ProactiveMetricsDetail/ProactiveMetricsDetailUtil";
import { getTimeAgo } from "_helpers";

export default function EmailDetailsHeader({
  conversation,
  msgCount,
  lastReplyDate,
  emailSubject,
}) {
  const lastReply = getTimeAgo(lastReplyDate, false);
  const isIncomingMessage = conversation.direction.toLowerCase() === "incoming";
  const isMessageActioned = conversation.actioned
    ? conversation.actioned
    : conversation._embedded.userMessageActions &&
      conversation._embedded.userMessageActions.length > 0;

  return (
    <Box sx={styles.wrapper}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        {isIncomingMessage && !isMessageActioned && (
          <Box sx={{ ...styles.emailTag, ...styles.needsResponse }}>
            NEEDS RESPONSE
          </Box>
        )}
        <Box sx={styles.emailTag}>EMAIL</Box>
      </Box>

      <Box as="p" sx={styles.title}>
        {emailSubject}
      </Box>
      <Box as="p" sx={styles.stats}>
        {msgCount} {pluralize("message", msgCount)} • last reply {lastReply}
      </Box>
    </Box>
  );
}

const styles = {
  wrapper: {
    padding: "20px 24px",
    borderBottom: "1px solid rgb(241, 237, 230)",
  },
  needsResponse: {
    color: "#c0392b",
    backgroundColor: "#fbe9e7",
  },
  emailTag: {
    fontSize: "11px",
    color: "#7a8a80",
    backgroundColor: "#eef1ee",
    padding: "3px 9px",
    fontFamily: "FustatBold",
    borderRadius: "8px",
    display: "inline-block",
  },
  title: {
    color: "#12261b",
    fontFamily: "FustatExtraBold",
    fontSize: "22px",
    mt: "8px",
    mb: "0px",
  },
  stats: {
    color: "#98a29a",
    m: 0,
    fontFamily: "FustatMedium",
    fontSize: "14px",
  },
};
